import axiosInstance from "../api/axiosInstance";

const ReservationService = {

    processLock: async function(companyId: string = "0", reservationId: string = "", processLockVersion: number = 0) {
        return this.processLockType(companyId, reservationId, processLockVersion, "lock");
    },

    processOpen: async function(companyId: string = "0", reservationId: string = "", processLockVersion: number = 0) {
        return this.processLockType(companyId, reservationId, processLockVersion, "open");
    },

    processLockType: async(companyId: string = "0", reservationId: string = "", processLockVersion: number, processType: string) => {
        return await axiosInstance().post('/kiosk/v2/init.do',{
            companyId: companyId,
            reservationId: reservationId,
            processType: processType,
            processLockVersion: processLockVersion
          });
    }

}

export default ReservationService;